/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerActivityFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CustomerActivity, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { HistoryRequestBuilderRequestsMetadata, type HistoryRequestBuilder } from './history/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/activity
 */
export interface ActivityRequestBuilder extends BaseRequestBuilder<ActivityRequestBuilder> {
    /**
     * The history property
     */
    get history(): HistoryRequestBuilder;
    /**
     * GetCustomerActivity
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerActivity>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CustomerActivity | undefined>;
    /**
     * GetCustomerActivity
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ActivityRequestBuilderUriTemplate = "{+baseurl}/customers/activity";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ActivityRequestBuilderNavigationMetadata: Record<Exclude<keyof ActivityRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    history: {
        requestsMetadata: HistoryRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ActivityRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ActivityRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerActivityFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
